var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.31 12.493"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.843 12.493h11.582a.79.79 0 0 0 .716-.4.76.76 0 0 0 .013-.82L7.376.442a.821.821 0 0 0-1.458 0L.114 11.27a.76.76 0 0 0 .013.82.79.79 0 0 0 .716.403m5.205-3.071a.82.82 0 0 1 .6-.26.828.828 0 1 1-.833.833.78.78 0 0 1 .233-.573m-.234-1.9V4.19a.79.79 0 0 1 .247-.6.85.85 0 0 1 1.171 0 .79.79 0 0 1 .247.6v3.332a.833.833 0 0 1-1.666 0Zm7.5 4.138"
})));
export default SvgWarning;